import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["productSelect"]

  connect() {
    this.previousValues = new Map()
    this.handlingChange = false

    // Esperar a que Choices.js se inicialice
    setTimeout(() => {
      this.productSelectTargets.forEach(select => {
        this.storePreviousValue(select)
        this.attachChangeListener(select)
      })
    }, 200)
  }

  disconnect() {
    this.productSelectTargets.forEach(select => {
      this.detachChangeListener(select)
    })
  }

  storePreviousValue(select) {
    const value = select.choices ? select.choices.getValue(true) : select.value
    this.previousValues.set(select, value || '')
  }

  attachChangeListener(select) {
    const handler = this.handleSelectChange.bind(this)
    select._exclusionHandler = handler
    // Solo escuchar en el select nativo (Choices.js dispara change en el mismo elemento)
    select.addEventListener('change', handler)
  }

  detachChangeListener(select) {
    const handler = select._exclusionHandler
    if (handler) {
      select.removeEventListener('change', handler)
    }
  }

  handleSelectChange(event) {
    // Evitar re-entrancia cuando revertimos el valor
    if (this.handlingChange) return
    this.handlingChange = true

    try {
      const select = event.target
      const selectedValue = select.value

      if (!selectedValue || selectedValue === '') {
        this.previousValues.set(select, '')
        return
      }

      // Obtener todos los valores seleccionados en otros selects
      const otherSelectedValues = []
      this.productSelectTargets.forEach(otherSelect => {
        if (otherSelect === select) return

        const otherValue = otherSelect.choices ? otherSelect.choices.getValue(true) : otherSelect.value
        if (otherValue && otherValue !== '') {
          otherSelectedValues.push(String(otherValue))
        }
      })

      // Si el producto ya esta seleccionado en otro campo, mostrar confirmacion
      if (otherSelectedValues.includes(String(selectedValue))) {
        const selectedOption = select.querySelector(`option[value="${selectedValue}"]`)
        const productName = selectedOption ? selectedOption.textContent.trim() : 'seleccionado'

        if (!confirm(`El producto "${productName}" ya está en este menú. ¿Desea agregarlo de nuevo?`)) {
          // Si cancela, revertir al valor anterior
          const previousValue = this.previousValues.get(select) || ''
          if (select.choices) {
            select.choices.setChoiceByValue(previousValue)
          } else {
            select.value = previousValue
          }
          return
        }
      }

      // Guardar el nuevo valor como el valor anterior para la proxima vez
      this.previousValues.set(select, selectedValue)
    } finally {
      this.handlingChange = false
    }
  }

  // Método para ser llamado cuando se agrega un nuevo campo
  fieldAdded() {
    // Esperar a que Choices.js se inicialice en el nuevo campo
    setTimeout(() => {
      const newSelects = this.element.querySelectorAll('select[data-target*="productSelect"]')
      newSelects.forEach(select => {
        if (!select.hasAttribute('data-exclusion-listener')) {
          select.setAttribute('data-exclusion-listener', 'true')
          this.storePreviousValue(select)
          this.attachChangeListener(select)
        }
      })
    }, 300)
  }

  // Método para ser llamado cuando se elimina un campo
  fieldRemoved() {
    // No-op: ya no hay opciones deshabilitadas que actualizar
  }
}
